import _ from 'lodash';
import { useContext } from 'react';
import { config } from '../../../config';
import { PlatformInfoContext } from '../../../contexts/PlatformInfoContext';

interface ILanguageMenuProps {
  onLanguageChange: (language: string) => void;
}

interface LanguageMenuItem {
  text: string;
  onClick(): void;
}

export const LanguageMenu = (props: Readonly<ILanguageMenuProps>) => {
  const platformInfo = useContext(PlatformInfoContext);

  const languages = platformInfo?.languages ?? config.languages;
  const menuItems: LanguageMenuItem[] = languages.map(language => ({
    text: language,
    onClick: () => props.onLanguageChange(language),
  }));

  return (
    <ul>
      {_.map(menuItems, ({ onClick, text }) => (
        <li key={text}>
          <a onClick={onClick}>{text.toUpperCase()}</a>
        </li>
      ))}
    </ul>
  );
};
